const ACTION = {
   UPDATE_PHONE_NUMBER_COMPLETION: 'UPDATE_PHONE_NUMBER_COMPLETION',
   UPDATE_PHONE_NUMBER_COMPLETION_ERROR_TEXT: 'UPDATE_PHONE_NUMBER_COMPLETION_ERROR_TEXT'
}

export default ACTION;